import { api } from '../api';

// Action Types

export const Types = {
  SETACCOUNTDATA: 'set/account/data',
};

// Reducer

const initialState = {
  accountId: null,
  accountData: null,
  open: false,
  accountList: [],
  companyList: [],

};

export default (state = initialState, action) => {

  switch (action.type) {
    case Types.SETACCOUNTDATA:
      return { ...state, ...action.result };
    default:
      return state;
  }

};

// Action Creators

export const setAccountData = params => ({
  type: Types.SETACCOUNTDATA,
  result: params || initialState,
});



// WEBPACK FOOTER //
// ./src/redux/account.js